import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { HeroSection } from "@/components/HeroSection";
import { Steps } from "@/components/Steps";
import { Example } from "@/components/Example";
import { Waitlist } from "@/components/Waitlist";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="overflow-x-clip bg-[#FAF7F2]" data-testid="landing-page">
      <Nav />
      <main>
        <HeroSection />
        <Steps />
        <Example />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
